import { Client } from '../../../services/user.service';

/**
 * Filtra la lista de clientes del autocompletar de Liquidaciones Agencia.
 *
 * POR QUÉ EXISTE ESTE ARCHIVO
 *
 * Antes, el filtrado vivía como una función inline (`_filtrarClientes`) cerrada
 * sobre `this.clientes`. Eso la hacía imposible de testear de forma aislada y,
 * sobre todo, escondía la causa real del bug de la carrera (race) del
 * autocompletar: si el usuario escribía ANTES de que `cargarClientes()`
 * terminara, el filtro corría sobre un arreglo todavía vacío y, al llegar los
 * datos, las opciones nunca se recalculaban porque nada disparaba de nuevo el
 * `map`. Esta función pura es la pieza que SÍ se puede probar sola; quien la
 * invoque (el componente) es responsable de recalcularla cada vez que cambie
 * la lista de clientes, no solo cuando cambie lo que el usuario escribió.
 *
 * Mantiene exactamente la semántica previa: sin value → devuelve todo;
 * comparación por `includes` sobre `toLowerCase()` (NO normaliza acentos,
 * igual que el código original).
 */
export function filtrarClientes(
    clientes: Client[],
    value: string | Client | null
): Client[] {
    if (!value) {
        return clientes.slice();
    }
    const searchText = typeof value === 'string' ? value : value.cliente;
    const filterValue = searchText.toLowerCase();
    return clientes.filter((cliente) =>
        cliente.cliente.toLowerCase().includes(filterValue)
    );
}
